import { ConsumptionDataType } from "./ConsumptionDataType";

export class CurrentContractData {
    supplierName: string;
    supplierId: number | null;
    price: number | null;
    termFrom: Date | null;
    termTo: Date;
    isRate: boolean;
    rateEnd: Date | null;
    hasOffersWithSavings: boolean;
    contractId: number | null;
    isKilowantContract: boolean;
    consumptionData: ConsumptionDataType | null;
    utilityRate: number;
    saveVsEnergy: number;
    saveVsEnergyInUSD: number;
    communityRate: number;
    saveVsCommunity: number;
    saveVsCommunityInUSD: number;
    compareToCommunity: boolean;
    aiTaskId: number|null;
}